import { User } from '../models/user';

export class CreateUserSuccess {
    static readonly type = '[User] CreateUserSuccess';

    constructor(public payload: User) {}
}
